import '.ag{flex-shrink:0;}.ssr-plugin'
import '.a8{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.az{height:100%;}.ssr-plugin'
import '.b4{border:none;}.ssr-plugin'
import '.ca{background-color:transparent;}.ssr-plugin'
import '.cb{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.b9{position:sticky;}.ssr-plugin'
import '.cc{top:4rem;}.ssr-plugin'
import '.cd{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ce{padding-bottom:1rem;}.ssr-plugin'
import '.cf{margin-bottom:1rem;}.ssr-plugin'
import '.cg{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.ba{top:0px;}.ssr-plugin'
import '.bo{left:0px;}.ssr-plugin'
import '.bp{right:0px;}.ssr-plugin'
import '.bq{bottom:0px;}.ssr-plugin'
import '.ch{z-index:9999;}.ssr-plugin'
import '.ci{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.b8{justify-content:flex-end;}.ssr-plugin'
import '.b0{flex:1;}.ssr-plugin'
import '.c0{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ag a8 n az b4 ca cb"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e ad"
    >
      <div className="b9 cc cd t ce cf cg d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i ba bo bp bq ch t ci d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="a8 d b8 cg"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="b0 c0">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
